import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { change } from 'redux-form';

import { Filter, Main } from 'Containers/';
import UserProfileForm from './components/UserProfileForm';
import { UserProfileFieldEnum as Fields } from 'Common/FieldEnum';
import { fetchData, saveUserProfile } from './state/userprofile/actions';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import { LoadingPage } from 'Components';
import { USER_PROFILE_FORM_NAME } from 'Common/FormEnum';
import { submitDelay } from 'Common/GeneralHelper';
import { getIsDirty } from 'Common/Selectors/DirtySelector';

class UserProfileContainer extends Component {
  componentDidMount() {
    this.props.fetchData();
  }

  componentDidUpdate(prevProps) {
    errorToast(this.props, prevProps, 'fetchError');

    if (!prevProps.submitted && this.props.submitted) {
      createToast(
        toastType.success,
        'Success',
        'User Profile saved successfully',
        true
      );

      this.props.change(USER_PROFILE_FORM_NAME, Fields.OldPassword, '');
      this.props.change(USER_PROFILE_FORM_NAME, Fields.NewPassword, '');
      this.props.change(USER_PROFILE_FORM_NAME, Fields.ConfirmPassword, '');
    }
  }

  handleSubmit = values => {
    return submitDelay().then(() => {
      this.props.saveUserProfile(values);
    });
  };

  getMainProps = () => {
    return {
      toolbox: {
        formName: USER_PROFILE_FORM_NAME,
        saveButtonProps: {
          content: 'Save',
          loading: this.props.fetching || this.props.submitting,
          disabled: this.props.submitting,
        },
        shown: true,
      },
    };
  };

  render() {
    const { data } = this.props;

    return (
      <Fragment>
        {(this.props.fetching || this.props.submitting) && <LoadingPage />}
        <Filter title={'User Profile'} />
        <Main {...this.getMainProps()}>
          <UserProfileForm onSubmit={this.handleSubmit} initialValues={data} />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userprofile } = state.UserProfileState;
  ownProps.setPageLevelDirty(getIsDirty()(state));

  return {
    fetchError: userprofile.fetchError,
    fetching: userprofile.fetching,
    submitting: userprofile.submitting,
    submitted: userprofile.submitted,
    data: userprofile.data,
  };
};

export const UserProfile = withRouter(
  connect(
    mapStateToProps,
    { fetchData, saveUserProfile, change }
  )(UserProfileContainer)
);



// WEBPACK FOOTER //
// ./src/pages/userprofile/UserProfile.js